import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"display":"none"},
  "aria-hidden": "true"
}

import { swalConfirm, swalErrNotification, swalNotification } from '@/core/helpers/utils';
import useVatTu from '@/core/hooks/use-vat-tu';
import {
  IBienBanGiaiTheResponseBase,
  IPhieuNhapKhoResponseBase,
  IPhieuXuatKhoResponseBase,
  IVatTuResponseBase,
} from '@/core/interfaces/ApiResponses';
import { PhieuNhapKhoService } from '@/core/services/PhieuNhapKho.service';
import PhieuXuatKhoService from '@/core/services/Receipt.service';
import { computed, PropType, watch } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ConfirmationApproveDialog',
  props: {
  approveType: {
    type: String as PropType<
      'VAT_TU' | 'NHAP_KHO' | 'XUAT_KHO' | 'CONFIRM_BBGT' | 'APPROVE_BBGT'
    >,
    required: true,
  },
  bienBanGiaiThe: {
    type: Object as PropType<IBienBanGiaiTheResponseBase>,
    default: () => null,
  },
  isDisplay: {
    type: Boolean,
    required: true,
  },
  vatTu: {
    type: Object as PropType<IVatTuResponseBase>,
    default: () => null,
  },
  phieuNhapKho: {
    type: Object as PropType<IPhieuNhapKhoResponseBase>,
    default: () => null,
  },
  phieuXuatKho: {
    type: Object as PropType<IPhieuXuatKhoResponseBase>,
    default: () => null,
  },
},
  emits: ["on-close", "on-confirm"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const { duyetVatTu } = useVatTu();

const confirmLabel = computed(() =>
  props.approveType === 'CONFIRM_BBGT' ? 'Xác nhận' : 'Duyệt'
);

const description = computed(() => {
  switch (props.approveType) {
    case 'APPROVE_BBGT':
      if (!props.bienBanGiaiThe) {
        console.warn('No item to approve');
        return '';
      }

      return `Bạn có chắc chắn muốn phê duyệt biên bản giải thể có số biên bản ${props.bienBanGiaiThe?.so_bien_ban}?`;
    case 'CONFIRM_BBGT':
      if (!props.bienBanGiaiThe) {
        console.warn('No item to approve');
        return '';
      }

      return `Bạn có chắc chắn muốn xác nhận biên bản giải thể có số biên bản ${props.bienBanGiaiThe?.so_bien_ban}?`;
    case 'NHAP_KHO':
      if (!props.phieuNhapKho) {
        console.warn('No item to approve');
        return '';
      }

      return `Bạn có chắc chắn muốn phê duyệt phiếu nhập kho có số phiếu "${props.phieuNhapKho?.so_phieu}"?`;
    case 'XUAT_KHO':
      if (!props.phieuXuatKho) {
        console.warn('No item to approve');
        return '';
      }

      return `Bạn có chắc chắn muốn phê duyệt phiếu xuất kho có số phiếu "${props.phieuXuatKho?.so_phieu}"?`;
    case 'VAT_TU':
    default:
      return `Bạn có chắc chắn muốn phê duyệt vật tư "${props.vatTu?.ten_vat_tu}"?`;
  }
});

const confirm = async () => {
  if (props.approveType === 'CONFIRM_BBGT' || props.approveType === 'APPROVE_BBGT') {
    emit('on-confirm');
    return;
  }

  try {
    switch (props.approveType) {
      case 'NHAP_KHO':
        await PhieuNhapKhoService.duyetPhieuNhapKho({
          id: props.phieuNhapKho.id,
          ngay_hoan_thanh: new Date(),
        });

        break;
      case 'XUAT_KHO':
        await PhieuXuatKhoService.duyetPhieuXuat({
          id: props.phieuXuatKho.id,
          ngay_hoan_thanh: new Date(),
        });

        break;
      case 'VAT_TU':
      default:
        if (!props.vatTu) {
          console.warn('No item to approve');
          return;
        }

        await duyetVatTu({ vatTu: props.vatTu });

        break;
    }

    emit('on-confirm');

    await swalNotification(
      `${
        props.approveType === 'CONFIRM_BBGT' ? 'Xác nhận' : 'Duyệt'
      } thành công`,
      'success'
    );
  } catch (error) {
    emit('on-close');

    await swalErrNotification(error, 'Duyệt không thành công');
  }
};

let isPromptOpen = false;

watch(
  () => props.isDisplay,
  async (visible) => {
    if (!visible || isPromptOpen) {
      return;
    }

    isPromptOpen = true;

    try {
      const confirmed = await swalConfirm({
        title: 'Xác nhận',
        text: description.value,
        confirmButtonText: confirmLabel.value,
      });

      if (confirmed) {
        await confirm();
      } else {
        emit('on-close');
      }
    } finally {
      isPromptOpen = false;
    }
  },
  { immediate: true }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", _hoisted_1))
}
}

})